import { SlideFlagPOST, Stain } from "pwapi";

export const getReasonCatalog = (stain?: Stain) => {
  const heslide =
    stain?.abbreviation === "H&E"
      ? "recut"
      : SlideFlagPOST.order_request.REPEAT;

  const reasonCatalog: {
    [key: string]: {
      requestList?: string[];
      canChooseStain?: boolean;
      initialStain?: string;
    };
  } = {
    MISSING_EPIDERMIS: {
      canChooseStain: true,
      initialStain: "DEEPEP",
      requestList: [SlideFlagPOST.order_request.DEEPEP],
    },
    EMBEDDED_INCORRECTLY: {
      requestList: [SlideFlagPOST.order_request.REEMBED],
    },
    TANGENTIAL_SECTION: { canChooseStain: true },
    MISLABELED: {},
    DATA_ENTRY_ERROR: { canChooseStain: true },
    INCORRECT_ORDER: { requestList: [heslide] },
    BLURRY: { requestList: [SlideFlagPOST.order_request.RESCAN] },
    TILING: { requestList: [SlideFlagPOST.order_request.RESCAN] },
    SCAN_MISSING_TISSUE: { requestList: [SlideFlagPOST.order_request.RESCAN] },
    FOLDED_TISSUE: { canChooseStain: true },
    TISSUE_OUT_OF_SCAN_FIELD: {
      requestList: [heslide],
    },
    AIR_BUBBLE: { requestList: [SlideFlagPOST.order_request.RESCAN] },
    NO_COVERSLIP: { requestList: [SlideFlagPOST.order_request.RESCAN] },
    ORGANISM_RESCAN: { requestList: [SlideFlagPOST.order_request.RESCAN] },
    FORTYX_RESCAN: { requestList: [SlideFlagPOST.order_request.RESCAN] },
    REPEAT_STAIN: { requestList: [heslide] },
    OTHER: {
      requestList: [
        heslide,
        SlideFlagPOST.order_request.REEMBED,
        SlideFlagPOST.order_request.RESCAN,
      ],
      canChooseStain: true,
    },
  };

  return reasonCatalog;
};

export const initializeReasons = [
  SlideFlagPOST.reason.BLURRY,
  SlideFlagPOST.reason.TILING,
  SlideFlagPOST.reason.SCAN_MISSING_TISSUE,
  SlideFlagPOST.reason.AIR_BUBBLE,
  SlideFlagPOST.reason.NO_COVERSLIP,
  SlideFlagPOST.reason.ORGANISM_RESCAN,
  SlideFlagPOST.reason.FORTYX_RESCAN,
  SlideFlagPOST.reason.REPEAT_STAIN,
  SlideFlagPOST.reason.MISSING_EPIDERMIS,
];
